(function () {
  const PARAM_NAME = 'epik';
  const COOKIE_NAME = '_epik';
  const STORAGE_KEY = 'fs_pinterest_epik';
  const MAX_AGE_SECONDS = 60 * 60 * 24 * 180;
  const PINTEREST_EVENTS_WITH_CLICK_ID = new Set(['addtocart', 'initiatecheckout']);
  const sentEvents = new Set();

  function normalize(value) {
    return String(value || '').trim().slice(0, 512);
  }

  function setCookie(value) {
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `${COOKIE_NAME}=${encodeURIComponent(value)}; Max-Age=${MAX_AGE_SECONDS}; Path=/; SameSite=Lax${secure}`;
  }

  function persist(value) {
    const epik = normalize(value);
    if (!epik) return;

    setCookie(epik);

    try {
      window.localStorage.setItem(STORAGE_KEY, epik);
    } catch (error) {
      // Storage can be unavailable in private or restricted browser contexts.
    }
  }

  function readCookie() {
    const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_NAME}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function getClickId() {
    try {
      return normalize(window.localStorage.getItem(STORAGE_KEY)) || normalize(readCookie());
    } catch (error) {
      return normalize(readCookie());
    }
  }

  function withClickId(payload) {
    const clickId = getClickId();
    if (!clickId) return payload || {};

    return {
      ...(payload || {}),
      click_id: clickId,
    };
  }

  function normalizeEventName(eventName) {
    return String(eventName || '').trim().toLowerCase();
  }

  function decoratePintrkArgs(args) {
    if (!Array.isArray(args) || args[0] !== 'track') return args;
    const eventName = normalizeEventName(args[1]);
    if (!PINTEREST_EVENTS_WITH_CLICK_ID.has(eventName)) return args;

    args[2] = withClickId(typeof args[2] === 'object' && args[2] !== null ? args[2] : {});
    return args;
  }

  function copyPintrkProperties(source, target) {
    for (const key in source) {
      try {
        target[key] = source[key];
      } catch (error) {
        // Some browser-injected function properties can be read-only.
      }
    }
  }

  function wrapPintrk() {
    const current = window.pintrk;
    if (typeof current !== 'function' || current.__fsPinterestClickIdWrapped) return false;

    const wrapped = function () {
      return current.apply(this, decoratePintrkArgs(Array.prototype.slice.call(arguments)));
    };

    copyPintrkProperties(current, wrapped);
    wrapped.__fsPinterestClickIdWrapped = true;
    wrapped.__fsPinterestOriginal = current;
    window.pintrk = wrapped;
    return true;
  }

  function installPintrkWrapper() {
    if (wrapPintrk()) return;

    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (wrapPintrk() || attempts >= 40) {
        window.clearInterval(timer);
      }
    }, 250);
  }

  const currentEpik = new URLSearchParams(window.location.search).get(PARAM_NAME);
  if (currentEpik) {
    persist(currentEpik);
  }

  installPintrkWrapper();

  window.FukuokaSilkPinterest = {
    getClickId,
    withClickId,
    track(eventName, payload, dedupeKey) {
      const normalizedEventName = normalizeEventName(eventName);
      const clickId = getClickId();
      if (!clickId || !PINTEREST_EVENTS_WITH_CLICK_ID.has(normalizedEventName)) return false;
      if (typeof window.pintrk !== 'function') return false;

      wrapPintrk();

      const key = dedupeKey || `${normalizedEventName}:${clickId}:${JSON.stringify(payload || {})}`;
      if (sentEvents.has(key)) return false;
      sentEvents.add(key);

      window.pintrk('track', normalizedEventName, withClickId(payload || {}));
      return true;
    },
  };
})();
